module.exports = __webpack_public_path__ + "img/footer_tel_icon.85e51803.png";